import React from 'react';

const Contact = () => {
  return (
    <div>
      <h1>Contact Us</h1>
      <p>For more information or assistance, feel free to contact us. We’re here to help you make your website accessible to everyone.</p>
    </div>
  );
};

export default Contact;

